import { render, staticRenderFns } from "./InvalidAuth.vue?vue&type=template&id=6d4fd580&scoped=true"
import script from "./InvalidAuth.vue?vue&type=script&lang=js"
export * from "./InvalidAuth.vue?vue&type=script&lang=js"
import style0 from "./InvalidAuth.vue?vue&type=style&index=0&id=6d4fd580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4fd580",
  null
  
)

export default component.exports